import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Iter-311 — AI Avatar transparency badge.
 *
 * Render this next to any talent name / thumbnail when the API returns
 * `is_ai_avatar: true`. Clients must never confuse an AI-generated
 * likeness for a real photo, particularly for hands-on roles.
 *
 * Sizing follows the surrounding line-height — small chip that reads
 * "AI Avatar" with a Sparkles icon. Use `variant="dot"` for tight
 * badges (e.g. avatar corner) or `variant="chip"` (default) for lists.
 */
export function AIAvatarBadge({ variant = 'chip', className = '' }) {
  if (variant === 'dot') {
    return (
      <span
        data-testid="ai-avatar-dot"
        title="AI Avatar — this profile uses an AI-generated image"
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-fuchsia-600 text-white text-[10px] font-bold shadow ring-1 ring-white ${className}`}
      >
        AI
      </span>
    );
  }
  return (
    <span
      data-testid="ai-avatar-badge"
      title="AI Avatar — this profile uses an AI-generated image"
      className={`inline-flex items-center gap-1 rounded-full bg-fuchsia-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-fuchsia-700 border border-fuchsia-200 ${className}`}
    >
      <Sparkles size={11} strokeWidth={2.5} />
      AI Avatar
    </span>
  );
}

export default AIAvatarBadge;
